<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-files'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [widgetDisabled]="true"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="false"
  [isUptrendPositive]="true">
</app-kpi-widget>